import { GetterTree, ActionTree, MutationTree } from "vuex";
import { ListModel } from "../../shared/models/listModel";
import Vue from "vue";

const initialState = {
    inited: false,
    properties: [] as GlobalFilterProperty[],
    filteredProperties: [] as GlobalFilterProperty[],
    showDeletedProperties: false
};

const state = { ...initialState };

const getters: GetterTree<typeof state, any> = {
    inited: (state) => state.inited,
    properties: (state) => state.inited ? state.properties : [],
    filteredProperties: (state) => state.inited ? state.filteredProperties : [],
    showDeletedProperties: (state) => state.inited ? state.showDeletedProperties : false
};
const actions: ActionTree<typeof state, any> = {
    refreshFilter({ commit, rootGetters, dispatch, state }, replaceCurrent = true) {
        const utid = rootGetters["auth/claims"]?.utid;

        const currentCount = state.properties.length;
        Vue.axios.get<ListModel<GlobalFilterProperty>>("/globalFilters/GetPropertiesForGlobalFilter", {
            params: {
                $count: true,
                $skip: replaceCurrent ? 0 : currentCount,
                $orderby: "propertyId",
            }
        }).then(res => {
            if (replaceCurrent) {
                commit("setProperties", res.data.result);
            }
            else {
                commit("addProperties", res.data.result);
            }

            if (res.data.count && state.properties.length < res.data.count) {
                dispatch("refreshFilter", false);
            }
            else {
                Vue.axios.get<GlobalFilterDbSavedSettings>("/globalFilters/GetDbSavedPropertiesForGlobalFilter")
                .then((dbData) => {
                    const gfilter = JSON.parse(localStorage.getItem(`pms.utid_${utid}_gfilter`) || "{}");
                    const propertiesIds = gfilter.propertiesIds;
                    let selected: GlobalFilterProperty[] = [];

                    let showDeletedProperties = gfilter.showDeletedProperties ?? dbData.data.showDeletedProperties;
                    if (propertiesIds && propertiesIds.length > 0) {
                        selected = state.properties.filter(e => propertiesIds.indexOf(e.propertyId) != -1)
                    } 
                    else if (dbData.data.propertyGlobalFilter && dbData.data.propertyGlobalFilter.length > 0) {
                        selected = state.properties.filter(e => dbData.data.propertyGlobalFilter.indexOf(e.propertyId) != -1);
                    }
                    else {
                        selected = state.properties;
                        showDeletedProperties = false;
                    }

                    if (!showDeletedProperties){
                        selected = selected.filter(x => x.status);
                    }

                    const param = { propertiesIds: selected.map(e => e.propertyId), showDeletedProperties: showDeletedProperties };

                    Vue.axios.post("/globalFilters/SetGlobalPropertiesFilter", param).then(() => {
                        commit("setFilter", selected);
                        commit("setShowDeletedProperties", showDeletedProperties);
                        localStorage.setItem(`pms.utid_${utid}_gfilter`, JSON.stringify(param));
                    });
                });                
            }
        });
    }
};
const mutations: MutationTree<typeof state> = {
    reset: (state) => {
        Object.assign(state, initialState);
    },
    setProperties: (state, value) => {
        state.properties = value.slice();
    },
    addProperties: (state, value) => {
        state.properties.push(...value);
    },
    setFilter: (state, value) => {
        state.filteredProperties = value.slice();
        state.inited = true;
    },
    setShowDeletedProperties: (state, value) => {
        state.showDeletedProperties = value;
    }
};

export interface UnitLevelOwners {
    id: number;
    name: string;
    propertyId: number;
    isOwnerEligibleForIssuingOwnersInvoices: boolean;
}

export interface GlobalFilterProperty {
    propertyId: number;
    name: string;
    propertyType: string;
    shortName: string;
    address: string;
    postalCodeAndCity: string;
    ownerId?: number;
    ownerName: string;
    status: boolean;
    isOwnerEligibleForIssuingOwnersInvoices: boolean;
    unitLevelOwners: UnitLevelOwners[];
}

export interface GlobalFilterDbSavedSettings {
    propertyGlobalFilter: number[];
    showDeletedProperties: boolean;
}

export default {
    namespaced: true,
    state: () => state,
    getters,
    actions,
    mutations
};